import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const TESTIMONIALS = [
{ quote: "AssetCare365 transformed how I manage my Delhi NCR property from Canada. The monthly video updates and detailed reports give me complete confidence — I always know exactly what's happening.", name: "Rajiv Mehta", location: "Toronto, Canada", property: "Luxury Apartment, Gurgaon", initials: "RM" },
{ quote: "They found a verified tenant within 3 weeks, handled all the legalities, and have been sending me pristine monthly summaries ever since. The transparency is truly unmatched.", name: "Priya Sundaram", location: "London, UK", property: "Villa, Bengaluru", initials: "PS" },
{ quote: "As someone with multiple properties across Mumbai and Hyderabad, having one accountable team with genuine transparency was exactly what I needed. Highly recommend to every NRI.", name: "Anil Sharma", location: "Dubai, UAE", property: "Commercial + 2 Residential, Mumbai", initials: "AS" },
{ quote: "Their on-ground team's professionalism is exceptional. From the initial property health check to ongoing management — the experience has been seamless and stress-free.", name: "Deepa Krishnan", location: "Singapore", property: "Premium Apartment, Hyderabad", initials: "DK" }];


export function Testimonials() {
  return (
    <section className="relative py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="container-luxury">
        <SectionHeading eyebrow="Client Stories" title="Trusted by NRIs" titleAccent="Worldwide" subtitle="Hear from property owners who now enjoy peace of mind — no matter where in the world they call home." />
      </div>

      <div className="mt-16 relative">
        <div className="mask-fade-edges overflow-hidden">
          <motion.div
            className="flex gap-6 will-change-transform"
            animate={{ x: [0, -2560] }}
            transition={{ duration: 40, ease: "linear", repeat: Infinity }}
            style={{ width: "max-content" }}>

            {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) =>
            <div key={`${t.name}-${i}`} className="w-[360px] shrink-0 rounded-2xl border border-navy-100 bg-white p-8 shadow-sm">
                <Quote size={24} className="text-emerald-400/60 mb-5" strokeWidth={1.5} />
                <p className="text-sm leading-relaxed text-navy-700/80 text-balance">AssetCare365 transformed how I manage my Delhi NCR property from Canada. The monthly video updates and detailed reports give me complete confidence , I always know exactly what's happening.</p>
                <div className="mt-8 flex items-center gap-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-navy-800 text-white text-xs font-semibold shrink-0">{t.initials}</div>
                  <div>
                    <p className="text-sm font-semibold text-navy-800 tracking-tight">{t.name}</p>
                    <p className="text-xs text-navy-600/60">{t.location}</p>
                    <p className="text-xs text-emerald-600 mt-0.5">{t.property}</p>
                  </div>
                </div>
              </div>
            )}
          </motion.div>
        </div>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2.5 rounded-full border border-gold-200 bg-gold-50 px-6 py-3">
            <span className="text-gold-500 text-lg tracking-tight">★★★★★</span>
            <span className="text-sm font-medium text-navy-700">Rated 5/5 by NRI clients across 12 countries</span>
          </div>
        </div>
      </Reveal>
    </section>);

}